import { Skeleton } from "primereact/skeleton";
import { StatisticCard } from "./StatisticCard/StatisticCard";

export interface StaticisPanelCard {
  header: string;
  tooltip: string;
  value: any;
  id: string;
  difference?: any;
}

export interface StatisticPanelsProps {
  cards?: StaticisPanelCard[] | undefined;
}

export const StatisticPanels: React.FC<StatisticPanelsProps> = ({ cards }) => {
  const statisticPanels = cards?.map(({ header, tooltip, value, id, difference }, index) => ({
    header,
    value,
    tooltip,
    id,
    index,
    difference
  })) ?? [];

  // Default skeleton objects when no data is available
  const fallbackPanels = Array.from({ length: 6 }).map((_, index) => ({
    header: "Loading...",
    value: <Skeleton />,
    tooltip: "",
    id: `skeleton-${index}`,
    index,
    difference: <Skeleton />
  }));

  return (
    <div className="card">
      <div
        style={{
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {(statisticPanels.length > 0 ? statisticPanels : fallbackPanels).map(
          ({ header, tooltip, value, id, difference, index  }) => (
            <StatisticCard
              key={id}
              id={id}
              header={header}
              value={value}
              difference={difference}
              tooltip={tooltip}
              index={index}
            />
          )
        )}
      </div>
    </div>
  );
};
